import { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as XLSX from "xlsx";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, Grid, ExcelUpload, FormControl, Table } from "@/comn/components";
import {
    useForm,
    useToast,
    useFetch,
    useModal,
    useAuth,
    useStore,
    useGrid,
    usePopup,
    useResource,
    useExcel,
    usePage,
} from "@/comn/hooks";
import { BASE, URLS, APIS, SF_LPCO_INFO_R, SG_LPCO_ADDITM_LIST_U } from "./services/OsciCfgnAdtnlItmService";
import { CommonErrors } from "@/comn/components";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn";

/*
 * @ 화면 컴포넌트 주석
 * @ 메타 시스템을 참고 하여 표준 단어와 용어를 사용하여 작성
 * @ !== ... ==! 치환 부호는 개발 완료 후 한글 주석을 인지하여 제거하기 위한 표시
 * @ 기본 여러줄의 주석 형태를 사용
 * @ 포맷
 * @ [화면명 영문]
 * @ [지환부호시작] [화면명 한글] [치환부호종료]
 *
 * 화면명 영문
 * !== 화면명 한글 ==!
 */

/*
 * Modify Additional Item
 * !== Additional Item 수정 ==!
 */
export const OSCI0203008S = () => {
    const { pgeUid, menuId } = usePage({
        auth: ["auth_osci0004"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { appFmId } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!
    const { openPopup } = usePopup();
    const [lpcoAddItmList, setLpcoAddItmList] = useState(comnUtils.getGridData([]));
    // Component codes configured for this LPCO form !== 이 LPCO 양식에 설정된 컴포넌트 코드 ==!
    const [cpntCdList, setCpntCdList] = useState<any[]>([]);

    // original data
    const orginDataRef = useRef({ info: {}, asinList: [] });

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0116" },
            { area: "comnCd", comnCd: "OSC0120" },
            { area: "comnCd", comnCd: "OSC0038" },
            { area: "comnCd", comnCd: "OSC0119" },
            { area: "comnCd", comnCd: "OSC0128" },
            { area: "comnCd", comnCd: "OSC0100" },
            { area: "comnCd", comnCd: "OSC0113" },
        ],
    });
    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        // Register LPCO Component !== LPCO Component 등록 ==!
        lpcoInfoRgsr: useForm({
            defaultSchema: SF_LPCO_INFO_R,
            defaultValues: { orgCd: auth.get("orgCd"), orgNm: auth.get("orgNm") },
        }),
    };

    /*
     * Declaration Grid
     * !== 그리드 정의 ==!
     */
    const grid = {
        // Component List !== Component 목록 ==!
        appAddItmList: useGrid({
            defaultSchema: SG_LPCO_ADDITM_LIST_U,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const render = {
        grid_LpcoAddItmList: {
            head: {},
            cell: {},
            edit: {
                additmCpntCd: (props: any) => {
                    const { rowValues } = props;

                    return (
                        <FormControl
                            type="select"
                            options={[...cpntCdList]}
                            value={rowValues.additmCpntCd}
                            onChange={(v) => {
                                grid.appAddItmList.updateRow({ ...rowValues, additmCpntCd: v });
                            }}
                        />
                    );
                },
                inpTpCd: (props: any) => {
                    const { binding, rowValues, value } = props;

                    return (
                        <FormControl
                            type="select"
                            comnCd="OSC0128"
                            area="comnCd"
                            value={rowValues.inpTpCd}
                            excludes={["RB"]}
                            onChange={(v) => {
                                if (v != "CP" && v != "CS") {
                                    rowValues.comnCd = "";
                                    rowValues.comnCdNm = "";
                                }
                                if (v != "SP") {
                                    rowValues.optTbNm = "";
                                    rowValues.optColNm = "";
                                    rowValues.optColCn = "";
                                }
                                if (v == "NI") {
                                    rowValues.adtnlItmMaxLenVal = null;
                                }

                                grid.appAddItmList.updateRow({ ...rowValues, inpTpCd: v });
                                console.log("value ", v);
                            }}
                        />
                    );
                },
                comnCd: (props: any) => {
                    const { binding, rowValues, value } = props;
                    //console.log("binding, rowValues, value", binding, rowValues, value);
                    let bEdit = rowValues.inpTpCd == "CP" || rowValues.inpTpCd == "CS";

                    return (
                        <>
                            <FormControl
                                type="text"
                                value={rowValues.comnCd}
                                onChange={(v) => {}}
                                edit={bEdit}
                                disabled={true}
                                rightButton={{
                                    icon: "search",
                                    onClick: () => {
                                        //localhost:3470/eswo/comn/ppup/comn-cd-m?ppup=Y
                                        http: modal.openModal({
                                            // url 로 팝업창의 주소를 기입
                                            url: lpcoEnvs.frontComnCdMPpup,
                                            // 팝업창에 보낼 파라메터 정의
                                            params: { ppup: "Y" },
                                            size: "md",
                                            draggable: true,
                                            // 팝업창에서 modal.postMessage 메소드 실행시 callback 함수
                                            callback: (data) => {
                                                console.log(data);
                                                if (data != null && data != "") {
                                                    grid.appAddItmList.updateRow({
                                                        ...rowValues,
                                                        comnCd: data.code,
                                                        comnCdNm: data.label,
                                                    });
                                                    modal.closeModal();
                                                }
                                            },
                                        });
                                    },
                                }}
                            />
                            <FormControl type="text" edit={bEdit} disabled={true} value={rowValues.comnCdNm} />
                        </>
                    );
                },
                optTbNm: (props: any) => {
                    const { binding, rowValues, value } = props;
                    //console.log("binding, rowValues, value", binding, rowValues, value);
                    let bEdit = rowValues.inpTpCd == "SP";
                    return (
                        <>
                            <FormControl
                                type="text"
                                value={rowValues.optTbNm}
                                onChange={(v) => {
                                    grid.appAddItmList.updateRow({
                                        ...rowValues,
                                        optTbNm: v,
                                    });
                                }}
                                edit={bEdit}
                                required={bEdit}
                            />
                        </>
                    );
                },
                optColNm: (props: any) => {
                    const { binding, rowValues, value } = props;
                    //console.log("binding, rowValues, value", binding, rowValues, value);
                    let bEdit = rowValues.inpTpCd == "SP";
                    return (
                        <FormControl
                            type="text"
                            value={rowValues.optColNm}
                            onChange={(v) => {
                                grid.appAddItmList.updateRow({
                                    ...rowValues,
                                    optColNm: v,
                                });
                            }}
                            edit={bEdit}
                            required={bEdit}
                        />
                    );
                },
                optColCn: (props: any) => {
                    const { binding, rowValues, value } = props;
                    //console.log("binding, rowValues, value", binding, rowValues, value);
                    let bEdit = rowValues.inpTpCd == "SP";
                    return (
                        <FormControl
                            type="text"
                            value={rowValues.optColCn}
                            onChange={(v) => {
                                grid.appAddItmList.updateRow({
                                    ...rowValues,
                                    optColCn: v,
                                });
                            }}
                            edit={bEdit}
                            required={bEdit}
                        />
                    );
                },
                adtnlItmMaxLenVal: (props: any) => {
                    const { binding, rowValues, value } = props;
                    // Numeric input is limited by range values, not by max length !== 숫자 입력은 최대길이가 아니라 범위값으로 제한 ==!
                    let bEdit = rowValues.inpTpCd != "NI";
                    return (
                        <FormControl
                            type="number"
                            value={rowValues.adtnlItmMaxLenVal}
                            max={4000}
                            maxLength={4}
                            onChange={(v) => {
                                grid.appAddItmList.updateRow({
                                    ...rowValues,
                                    adtnlItmMaxLenVal: v,
                                });
                            }}
                            edit={bEdit}
                        />
                    );
                },
            },
            row: null,
            checkbox: null,
        },
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        /* Register Additional Info !== Additional Info 등록 ==! */
        saveAppAddItm: useFetch({
            api: (data) => APIS.saveAppAddItm({ ...data }),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.osc.00006" /**Processed successfully. */,
                    onConfirm: () => {
                        navigate(URLS.osci0203007s + "/" + data.appSaveInfo?.content?.appFmId);
                    },
                    onCancel: () => {
                        navigate(URLS.osci0203007s + "/" + data.appSaveInfo?.content?.appFmId);
                    },
                });
            },
            onError: (error) => {
                console.log(error);
                if (error.response.status === 400) {
                    console.log(error.response.data);
                    form.lpcoInfoRgsr.setErrors(error.response.data.errors);
                }

                const errMsg = error?.response?.data?.errorMessage || "msg.osc.00015";
                modal.openModal({
                    content: errMsg,
                });
            },
        }),
        getAppDtl: useFetch({
            api: async (data) => await APIS.getAppDtl(appFmId),
            enabled: !!appFmId,
            onSuccess: async (data) => {
                console.log("fetch data ", data);
                form.lpcoInfoRgsr.setValues({ ...data.appInfo?.content.info } || {});
                console.log("data.appInfo?.content.asinList ", data.appInfo?.content.addItmList);

                orginDataRef.current.info = { ...data.appInfo?.content.info } || {};
                orginDataRef.current.asinList = data.appInfo?.content.asinList || [];

                // Options must land before the grid renders its rows !== 그리드가 행을 그리기 전에 옵션이 들어와야 한다 ==!
                const info = data.appInfo?.content.info;
                const cpntList = await lpcoUtils
                    .getCpntList({
                        orgCd: info?.orgCd,
                        appCdNo: info?.appCdNo,
                        appTpCd: info?.appTpCd,
                    })
                    .catch(() => []);
                // Keep the fixed components out, same as the grid schema excludes !== 그리드 스키마 excludes와 동일 제외 ==!
                setCpntCdList(cpntList.filter((c: any) => !["DCL", "ATC", "PAY", "MSG", "CON"].includes(c.value)));

                grid.appAddItmList.setData(comnUtils.getGridData([...data.appInfo?.content.addItmList]));
            },
            onError: (error) => {},
        }),
    };
    /*
     * 화면에서 사용하는 이벤트, 함수를 선언
     * 기본 변수명은 메타 단어 조합 카멜 표기법을 따름
     * fetch 를 호출 하는 메소드: fetch 명과 동일하게 작성
     * 버튼이나 그리드의 이벤트의 경우 : [이벤트종류]_[이벤트대상타입]_[이벤트대상명]
     * 이벤트 대상 타입 : Btn , Grid ... 카멜표기법으로 표시, 첫글자 대문자
     * 이벤트 명 : 카멜표기법으로 표시, 첫글자 대문자
     *
     * const handler = {
     *      [handler 이름] : ()=>{ 함수 },
     *      click_Btn_Save : 저장버튼 클릭
     *      click_Grid_RpckItmAppList : 재포장 품목 신청서 그리드 클릭
     *      ...
     * }
     */
    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    // ORG LIST
    const [orgCdList, setOrgCdList] = useState([]);
    // ORG LPCO LIST
    const [orgLpcoList, setOrgLpcoList] = useState([]);

    const handler = {
        // Save Component !== Additional Info 저장 ==!
        saveAppAddItm: form.lpcoInfoRgsr.handleSubmit(() => {
            const appAddItmList = grid.appAddItmList.getData();

            let bCheck = true;
            if (!appAddItmList || appAddItmList.length == 0) {
                // Please enter additional items. !== 추가 항목을 입력하세요. ==!
                bCheck = false;
                modal.openModal({
                    content: "msg.osc.00014",
                });
            } else {
                // grid validate
                let errResult = grid.appAddItmList.validate() || {};
                errResult["errors"] = errResult?.errors || [];

                //  inpTpCd CP or CS 면 comnCd 필수
                //  inpTpCd SP 면 optTbNm optColNm optColCn 필수
                const appAtcmList = grid.appAddItmList.getViewData();
                /* msg.osc.00013 Mandatory fields */
                let idx = 1;
                for (const item of appAtcmList) {
                    const inpTpCd = item.inpTpCd;
                    console.log("inpTpCd ", inpTpCd);
                    if (inpTpCd == "CP" || inpTpCd == "CS") {
                        console.log("item.comnCd ", item.comnCd);
                        if (!item.comnCd) {
                            errResult.errors.push(lpcoUtils.getErrorObj(idx, "L_COMN_CD", "msg.osc.00013", ""));
                        }
                    } else if (inpTpCd == "SP") {
                        if (!item.optTbNm) {
                            errResult.errors.push(lpcoUtils.getErrorObj(idx, "L_OPT_TB_NM", "msg.osc.00013", ""));
                        }
                        if (!item.optColNm) {
                            errResult.errors.push(lpcoUtils.getErrorObj(idx, "L_OPT_CD_COL", "msg.osc.00013", ""));
                        }
                        if (!item.optColCn) {
                            errResult.errors.push(lpcoUtils.getErrorObj(idx, "L_OPT_CD_NM_COL", "msg.osc.00013", ""));
                        }
                    }
                    idx++;
                }
                if (errResult && errResult.errors?.length > 0) {
                    // sort by row
                    errResult.errors = lpcoUtils.errorListSortByRow(errResult.errors);
                    // error layer popup
                    modal.openModal({
                        content: <CommonErrors {...errResult} />,
                        size: "lg",
                        draggable: true,
                    });
                } else {
                    const data = { ...form.lpcoInfoRgsr.getValues(), addItmList: appAddItmList };
                    modal.openModal({
                        content: "msg.osc.00090" /**Do you want to save ? */,
                        onConfirm: () => {
                            fetch.saveAppAddItm.fetch(data);
                        },
                        callback: (data) => {
                            alert(data);
                        },
                    });
                }
            }
        }),
        click_Btn_AddGridList: () => {
            // adtnlItmSrno
            const gridData = grid.appAddItmList.getData();

            let maxAdtnlItmSrno = 0;
            gridData.forEach((obj, idx) => {
                console.log("foreach ", obj, idx);
                if (obj.adtnlItmSrno >= maxAdtnlItmSrno) {
                    maxAdtnlItmSrno = obj.adtnlItmSrno;
                }
            });

            grid.appAddItmList.addRow({ adtnlItmSrno: ++maxAdtnlItmSrno, rqrdInpYn: "N" });
        },
        click_Btn_DeleteGridList: () => {
            const seltList: any[] = grid.appAddItmList.getChecked() || [];
            if (comnUtils.isEmpty(seltList)) {
                modal.openModal({ content: "msg.osc.00009" });
                return;
            }

            grid.appAddItmList.deleteRow("checkbox");

            // modal.openModal({
            //     content: "msg.osc.00095",
            //     onConfirm: () => {
            //         grid.lpcoAtchFileList.deleteRow("checkbox");
            //     },
            // });
        },
        refreshOrgCdList: async () => {
            console.log("refreshOrgCdList");
            setOrgCdList((await lpcoUtils.getOrgCdList()) || []);
        },
        refreshOrgLpcoList: async (usrOrgCd: any) => {
            console.log("refreshOrgLpcoList");
            if (usrOrgCd) setOrgLpcoList((await lpcoUtils.getOrgLpcoByPrcsList(usrOrgCd)) || []);
            else setOrgLpcoList([]);
        },
        setAppDtl: async (appFmId: any, bInit: boolean) => {
            fetch.getAppDtl.fetch(appFmId);
        },
    };

    useEffect(() => {
        handler.setAppDtl(appFmId, true); // lpco app info
    }, []);

    return (
        <Page
        // id={pgeUid}
        // title={t("T_ADTNL_FLD_MDFC")}
        // navigation={{
        //     base: comnEnvs.base,
        //     nodes: [
        //         ...BASE.nodes,
        //         { path: "/lpco/cfgn/adtnlitm/osci0203006q", label: "T_ADTNL_FLD_SRCH" },
        //         { path: "/lpco/cfgn/adtnlitm/osci0203008s/" + appFmId, label: "T_ADTNL_FLD_MDFC" },
        //     ],
        // }}
        >
            <Group>
                <Group.Body>
                    <Group.Title title={"T_LPCO_APP_INFO"} titleSize={2}></Group.Title>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.lpcoInfoRgsr.schema.orgNm} options={orgCdList}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.lpcoInfoRgsr.schema.appNm}
                                options={orgLpcoList}
                                onChange={(ev: any) => {
                                    console.log(ev);
                                }}
                            ></Group.Control>
                            <Group.Control {...form.lpcoInfoRgsr.schema.appTpCd}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Title title={"L_ADTNL_INFO_LST"} titleSize={2}></Group.Title>
                    <Layout direction="row">
                        <Layout.Left></Layout.Left>
                        <Layout.Right>
                            <Button
                                role="gridAdd"
                                onClick={() => {
                                    handler.click_Btn_AddGridList();
                                }}
                            ></Button>
                            <Button
                                role="gridDelete"
                                onClick={() => {
                                    handler.click_Btn_DeleteGridList();
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                    {/*
                     * 그리드
                     * @ 그리드 스키마 주입 : {...grid.[그리드이름].grid}
                     * @ 데이터 data={fetch.[fetch 명].data?.[api 리턴 vo 명]}
                     * @ 셀클릭이벤트 연결 : onCellClick={handler.[그리드 이벤트 핸들러명]}
                     */}
                    <Grid
                        {...grid.appAddItmList.grid}
                        data={lpcoAddItmList} /* fetch.getRpckItmAppList.data?.lpcoAddItmList */
                        render={render.grid_LpcoAddItmList}
                        // onCellClick={handler.click_Grid_RpckItmAppList}
                        // onRowClick={handler.click_GridRow_RpckItmAppList}
                    />
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.osci0203006q);
                        }}
                    ></Button>
                    <Button
                        role="reset"
                        onClick={() => {
                            //form.lpcoInfoRgsr.reset({ ...orginDataRef.current.info });
                            grid.appAddItmList.resetData();
                        }}
                    ></Button>
                </Layout.Left>
                <Layout.Right>
                    <Button role="save" onClick={handler.saveAppAddItm}></Button>
                    <Button role="cancel" onClick={() => navigate(`${URLS.osci0203007s}/${appFmId}`)}></Button>
                </Layout.Right>
            </Layout>
        </Page>
    );
};
